import { ProductsCombinationTypes } from '../enums/products-combination-types.enum';

export interface IKioskReservationModel {
  firstName: string;
  lastName: string;
  driverBirthDate?: Date;
  driverPhone: string;
  driverEmail: string;
  reservationNumber: number;
  carDetails?: KioskCarDetailsModel;
  pickupDateTime?: Date;
  returnDateTime?: Date;
  rentalDays: number;
  totalPayed: number;
  currency: string;
  pickupStationName: string;
  returnStationName: string;
  airportFee: number;
  includedVat: boolean;
  productsCombinations: KioskProductsCombinationModel[];
}

export class KioskReservationModel implements IKioskReservationModel {
  firstName: string;
  lastName: string;
  driverBirthDate?: Date | undefined;
  driverPhone: string;
  driverEmail: string;
  reservationNumber: number;
  carDetails?: KioskCarDetailsModel;
  pickupDateTime?: Date;
  returnDateTime?: Date;
  rentalDays: number;
  totalPayed: number;
  currency: string;
  pickupStationName: string;
  returnStationName: string;
  airportFee: number;
  additionalDrivers: number;
  includedVat: boolean;
  productsCombinations: KioskProductsCombinationModel[];

  constructor() {
    this.firstName = '';
    this.lastName = '';
    this.driverPhone = '';
    this.driverEmail = '';
    this.currency = '';
    this.pickupStationName = '';
    this.returnStationName = '';
    this.productsCombinations = [];
    this.airportFee = 0;
    this.rentalDays = 0;
    this.totalPayed = 0;
    this.reservationNumber = 0;
    this.additionalDrivers = 0;
    this.pickupDateTime = undefined;
    this.pickupDateTime = undefined;
    this.carDetails = undefined;
    this.includedVat = true;
  }
}

export interface IKioskCarDetailsModel {
  group: string;
  carNumber: string;
  manufacturer: string;
  modelName: string;
  isAuto: boolean;
  passengers: string;
  suitcases: number;
  doors: number;
  photoUrl: string;
}

export class KioskCarDetailsModel implements IKioskCarDetailsModel {
  group: string;
  carNumber: string;
  manufacturer: string;
  modelName: string;
  isAuto: boolean;
  passengers: string;
  suitcases: number;
  doors: number;
  photoUrl: string;

  constructor() {
    this.group = '';
    this.carNumber = '';
    this.manufacturer = '';
    this.modelName = '';
    this.passengers = '';
    this.photoUrl = '';
    this.suitcases = 0;
    this.doors = 0;
    this.isAuto = true;
  }
}

export interface IKioskProductsCombinationModel {
  type: ProductsCombinationTypes;
  productsIds: string[];
}
export class KioskProductsCombinationModel implements IKioskProductsCombinationModel {
  type: ProductsCombinationTypes;
  productsIds: string[];

  constructor() {
    this.type = ProductsCombinationTypes.AtLeastOne;
    this.productsIds = [];
  }
}